import { Row, Col, Form, Input, Space } from "antd";

import { AttachFile, DatePicker } from "../../../../../../../components";
import { AiOutlineCloudUpload } from "react-icons/ai";
import { Moment } from "moment";

const { RangePicker } = DatePicker;

export const MaternityLeaveLetterForm = () => {
  const form = Form.useFormInstance();

  const onCalendarChange = (dates: any) => {
    if (dates) {
      const startDate = dates[0];
      const endDate = startDate.clone().add(6, "month").endOf("day");
      const eExpectedReturnDate = dates[1]
        ? (dates[1] as Moment).clone().add(1, "day")
        : endDate.clone().add(1, "day");
      form.setFieldValue("eVacationPeriod", [startDate, endDate]);
      form.setFieldValue("eExpectedReturnDate", eExpectedReturnDate);
    }
  };

  return (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="eFileContent">
          <AttachFile>
            <Space style={{ fontSize: 15 }}>
              Chứng từ đính kèm
              <AiOutlineCloudUpload size={24} />
              (word, excel, pdf, jpg,...)
            </Space>
          </AttachFile>
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian xin nghỉ phép"
          name="eVacationPeriod"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <RangePicker
            className="min-w-full"
            onCalendarChange={onCalendarChange}
          />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian (dự kiến) trở lại làm việc"
          name="eExpectedReturnDate"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <DatePicker className="min-w-full" />
        </Form.Item>
      </Col>

      <Col span={24}>
        <Form.Item label="Lý do" name="eReason">
          <Input.TextArea />
        </Form.Item>
      </Col>
    </Row>
  );
};
